export default angular.module('app.holding.dashboard.onboarding')
  .directive('gmwValidatePassword', gmwValidatePassword)
  .name;

function gmwValidatePassword() {
  'ngInject';

  const directive = {
    link,
    restrict: 'A',
    require: 'ngModel',
  };
  return directive;

  function link(_scope, _element, _attrs, ctrl) {
    ctrl.$validators.validPassword = function validPassword(modelValue, viewValue) {
      const value = modelValue || viewValue;

      const result = !value || (
        angular.isString(value) &&
        value.length >= 8 &&
        value.length <= 50 &&
        value.match(/\d/) !== null &&
        value.match(/[a-zA-Z]/) &&
        !value.match(/['"\\/]/) // disallow " ' / \
      );
      return result;
    };
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/directives/validate-password/validate-password.js